import { Droppable } from "@hello-pangea/dnd";
import "./BuildArea.scss";
import Row from "./Row/Row";
import AddRowWithField from "./dropzones/AddRowWithField";
import RowClone from "./Row/RowClone";
import React from "react";
export default function BuildArea(props) {
  return (
    <Droppable
      key={`base`}
      droppableId={`base`}
      direction="vertical"
      type="row"
      renderClone={(provided, _, rubric) => {
        const rowIndex = rubric.source.index;
        const row = props.buildArea[rowIndex];
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className="dnd-clone-pos"
            style={{
              ...provided.draggableProps.style,
            }}
          >
            <RowClone row={row} />
          </div>
        );
      }}
    >
      {(providedBase) => {
        return (
          <div
            ref={providedBase.innerRef}
            className="right-panel"
            {...providedBase.droppableProps}
            style={{ minHeight: "46vh", maxHeight: "46vh" }}
          >

            {<AddRowWithField uiBlocks={props.uiBlocks} setBuildArea={props.setBuildArea} buildArea={props.buildArea} setUiBlocks={props.setUiBlocks} count={0} />}
            {props.buildArea.map((row, rowIndex) => (
              <React.Fragment key={row.id ?? rowIndex}>
                <Row key={rowIndex} props={{ ...props, row, rowIndex }} />
                <AddRowWithField uiBlocks={props.uiBlocks} setBuildArea={props.setBuildArea} buildArea={props.buildArea} setUiBlocks={props.setUiBlocks} count={rowIndex + 1} />
              </React.Fragment>
            ))}
            {providedBase.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
}
